export interface VideoItem {
  id: string;
  title: string;
  summary: string;
  content: string[];
  cover: string;
  categoryId: string;
  categoryName: string;
  publishTime: string;
  views: number;
  likes: number;
  duration: string;
  source: string;
  tags: string[];
}

export const videos: VideoItem[] = [
  {
    id: "star-1",
    title: "顶流歌手深夜发文疑似回应恋情传闻，评论区瞬间炸锅",
    summary: "凌晨两点，一则短短十二个字的动态让粉丝彻夜未眠，工作室随后给出回应。",
    content: [
      "凌晨两点零七分，一位长期位居各大音乐榜单前列的歌手在个人社交账号发布了一条仅十二个字的动态，配图是一张模糊的窗前夜景。短短十分钟内，评论数量突破十万，话题迅速冲上热搜榜首。",
      "不少粉丝从字里行间读出弦外之音，纷纷猜测这是对近日流传的恋情传闻的间接回应。也有理性网友指出，动态内容更多像是在分享创作状态，不必过度解读。",
      "截至发稿前，其工作室发布简短说明，表示艺人近期正在筹备新专辑，希望外界把注意力放在作品本身，同时感谢大家长期以来的关心与支持。",
    ],
    cover: "https://readdy.ai/api/search-image?query=entertainment%20news%20video%20thumbnail%20about%20a%20popular%20singer%20sharing%20a%20late%20night%20emotional%20message%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-star-01&orientation=landscape",
    categoryId: "star",
    categoryName: "明星动态",
    publishTime: "2026-10-14 02:07",
    views: 2846123,
    likes: 182340,
    duration: "04:18",
    source: "吃瓜视频原创",
    tags: ["热议", "独家"],
  },
  {
    id: "star-2",
    title: "一线女演员新剧杀青，片场路透首次曝光引发期待",
    summary: "历时四个月拍摄结束，剧组全员合影留念，造型细节被网友反复放大。",
    content: [
      "经过近四个月的紧张拍摄，一部备受期待的古装大剧于近日正式杀青。剧组发布的全员合影中，主演与工作人员笑容灿烂，现场气氛温馨。",
      "从曝光的片场路透来看，该剧在服化道上投入十足，主角的发冠与刺绣纹样都经过多轮考据与调整，力求还原时代质感。",
      "制片方透露，该剧目前已进入后期制作阶段，配乐与特效同步推进，具体上线时间将根据整体进度对外公布。",
    ],
    cover: "https://readdy.ai/api/search-image?query=entertainment%20news%20video%20thumbnail%20about%20an%20actress%20wrapping%20up%20a%20costume%20drama%20shoot%20on%20set%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-star-02&orientation=landscape",
    categoryId: "star",
    categoryName: "明星动态",
    publishTime: "2026-10-13 18:40",
    views: 1928476,
    likes: 121005,
    duration: "03:52",
    source: "吃瓜视频原创",
    tags: ["新片", "独家"],
  },
  {
    id: "star-3",
    title: "男团成员官宣单飞，粉丝评论区集体破防",
    summary: "一封手写长信公布个人发展计划，团体后续活动安排同步说明。",
    content: [
      "近日，某人气男团成员通过一封手写长信对外公布了自己的个人发展计划。信中写道，感谢一路同行的队友与歌迷，未来仍会以音乐为初心继续努力。",
      "消息发布后，相关话题在短时间内占据多个平台热搜位置，粉丝在评论区表达不舍，也送上祝福。",
      "经纪公司随后补充说明，团体并不会解散，成员将在各自领域尝试更多可能，团队合作舞台仍在规划之中。",
    ],
    cover: "https://readdy.ai/api/search-image?query=entertainment%20news%20video%20thumbnail%20about%20a%20boy%20band%20member%20announcing%20a%20solo%20debut%20on%20stage%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-star-03&orientation=landscape",
    categoryId: "star",
    categoryName: "明星动态",
    publishTime: "2026-10-12 20:15",
    views: 1567230,
    likes: 98760,
    duration: "05:06",
    source: "综合报道",
    tags: ["热议"],
  },
  {
    id: "star-4",
    title: "老牌影帝现身机场，朴素穿搭引路人围观合影",
    summary: "一身休闲装的他没有助理随行，面对求合影的路人一一微笑回应。",
    content: [
      "有网友在机场偶遇一位资深影帝，只见他身穿简单的深色外套与运动鞋，独自推着行李，没有大批随行人员。",
      "面对认出他的路人，他主动放慢脚步，耐心配合合影，还提醒大家注意脚下安全。整个过程被拍成短视频后迅速传播。",
      "不少网友留言称，真正的从容来自作品与修养，这样的日常片段比红毯更有温度。",
    ],
    cover: "https://readdy.ai/api/search-image?query=entertainment%20news%20video%20thumbnail%20about%20a%20veteran%20film%20award%20winner%20walking%20through%20an%20airport%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-star-04&orientation=landscape",
    categoryId: "star",
    categoryName: "明星动态",
    publishTime: "2026-10-11 09:30",
    views: 1183902,
    likes: 76450,
    duration: "02:44",
    source: "综合报道",
    tags: ["现场"],
  },
  {
    id: "social-1",
    title: "暴雨突袭南方多城，市民互助画面暖哭网友",
    summary: "积水中的一把把伞、一次次搀扶，记录下这座城市最真实的温度。",
    content: [
      "连日强降雨影响南方多座城市，部分路段出现积水。镜头记录下的不是慌乱，而是一个个互相搭把手的瞬间。",
      "便利店老板把货架空出来给路人避雨，外卖骑手把客人送到干燥处才继续送单，陌生人自发排成一列帮助老人通过深水路段。",
      "气象部门提醒，未来两日仍需注意防范强对流天气，出行尽量避开低洼路段，遇到积水不要贸然涉水。",
    ],
    cover: "https://readdy.ai/api/search-image?query=news%20video%20thumbnail%20about%20heavy%20rain%20flooding%20a%20southern%20city%20street%20with%20people%20helping%20each%20other%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-social-01&orientation=landscape",
    categoryId: "social",
    categoryName: "社会热点",
    publishTime: "2026-10-14 08:12",
    views: 2213450,
    likes: 164200,
    duration: "06:21",
    source: "吃瓜视频原创",
    tags: ["暖心", "现场"],
  },
  {
    id: "social-2",
    title: "地铁站突发晕倒事件，众人合力救援全程记录",
    summary: "从发现异常到救护车抵达，短短四分钟里出现了十几个身影。",
    content: [
      "早高峰时段，一名乘客在站台突然晕倒。监控画面显示，最先注意到情况的是身旁的两位上班族，他们一边呼喊工作人员一边上前查看。",
      "随后，站务员携带急救设备赶到，多位市民自发疏散围观人群，为救援留出空间。整个过程紧张但有序。",
      "医生提醒，公共场所遇到类似情况应第一时间拨打急救电话，在专业指导下进行救助，避免不当搬动造成二次伤害。",
    ],
    cover: "https://readdy.ai/api/search-image?query=news%20video%20thumbnail%20about%20commuters%20rescuing%20a%20fainting%20passenger%20in%20a%20metro%20station%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-social-02&orientation=landscape",
    categoryId: "social",
    categoryName: "社会热点",
    publishTime: "2026-10-13 12:05",
    views: 1788230,
    likes: 132780,
    duration: "05:14",
    source: "综合报道",
    tags: ["暖心", "热议"],
  },
  {
    id: "social-3",
    title: "外卖小哥捡到十万现金原地等待失主三小时",
    summary: "他说，钱不是自己的，丢了钱的人一定更着急。",
    content: [
      "一位外卖骑手在配送途中于路边捡到一个黑色背包，打开后发现里面装有大量现金与证件。他第一时间报警，并在原地等待失主。",
      "三个小时后，失主赶到，激动得说不出话来。骑手只是摆摆手说，换作谁都会这么做。",
      "平台方面表示，将对骑手的行为予以表彰。网友也纷纷留言，这份朴素的善意值得被更多人看见。",
    ],
    cover: "https://readdy.ai/api/search-image?query=news%20video%20thumbnail%20about%20a%20delivery%20rider%20returning%20lost%20cash%20to%20its%20owner%20on%20a%20city%20street%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-social-03&orientation=landscape",
    categoryId: "social",
    categoryName: "社会热点",
    publishTime: "2026-10-11 15:48",
    views: 1432760,
    likes: 110350,
    duration: "04:02",
    source: "综合报道",
    tags: ["暖心"],
  },
  {
    id: "social-4",
    title: "高校食堂推出9元自助餐，学生排队排到校门口",
    summary: "荤素搭配不限量，校方称只为让学生吃得好一点。",
    content: [
      "某高校食堂近日推出一档仅需九元的自助餐窗口，提供十几种菜品，荤素搭配不限量，迅速成为校园里的热门话题。",
      "中午用餐高峰，队伍从窗口一直排到食堂门外。不少学生表示，这样的价格与品质在校园里很难得。",
      "校方回应称，希望通过这样的方式保障学生基本用餐需求，同时也会根据反馈持续调整菜品结构。",
    ],
    cover: "https://readdy.ai/api/search-image?query=news%20video%20thumbnail%20about%20students%20lining%20up%20at%20a%20university%20canteen%20for%20cheap%20buffet%20meals%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-social-04&orientation=landscape",
    categoryId: "social",
    categoryName: "社会热点",
    publishTime: "2026-10-10 11:20",
    views: 998120,
    likes: 83110,
    duration: "03:33",
    source: "综合报道",
    tags: ["热议"],
  },
  {
    id: "fun-1",
    title: "猫咪误把扫地机器人当坐骑，全程淡定巡游客厅",
    summary: "主人拍下这一幕时笑到手机都拿不稳。",
    content: [
      "一位猫主人在家中拍下了这样的画面：自家橘猫稳稳坐在正在工作的扫地机器人上，随着它在客厅里来回巡游，表情却异常淡定。",
      "视频中，机器人遇到障碍物自动转向，猫咪竟然还能保持平衡，仿佛早已习惯这份专属座驾。",
      "这段画面上传后迅速走红，网友调侃称这是全屋最贵的代步工具，也是全屋最淡定的乘客。",
    ],
    cover: "https://readdy.ai/api/search-image?query=fun%20video%20thumbnail%20about%20a%20cat%20riding%20a%20robot%20vacuum%20cleaner%20around%20a%20living%20room%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-fun-01&orientation=landscape",
    categoryId: "fun",
    categoryName: "趣味短片",
    publishTime: "2026-10-13 21:33",
    views: 3120450,
    likes: 245600,
    duration: "01:28",
    source: "吃瓜视频原创",
    tags: ["搞笑"],
  },
  {
    id: "fun-2",
    title: "爸爸辅导作业气到语无伦次，孩子一句话全场笑翻",
    summary: "\"爸爸你别急，我慢慢想\"——瞬间让大人破功。",
    content: [
      "一段家庭日常视频里，爸爸正在辅导孩子写作业，语气从耐心逐渐变成无奈，最后几乎语无伦次。",
      "就在气氛快要绷不住的时候，孩子抬起头认真地说：\"爸爸你别急，我慢慢想。\"一句话让原本生气的爸爸愣在原地。",
      "视频发出后引发大量家长共鸣，评论区清一色的\"这不是我家吗\"。",
    ],
    cover: "https://readdy.ai/api/search-image?query=fun%20video%20thumbnail%20about%20a%20dad%20losing%20his%20temper%20while%20tutoring%20homework%20at%20a%20desk%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-fun-02&orientation=landscape",
    categoryId: "fun",
    categoryName: "趣味短片",
    publishTime: "2026-10-12 19:02",
    views: 2650110,
    likes: 198770,
    duration: "02:15",
    source: "综合报道",
    tags: ["搞笑", "热议"],
  },
  {
    id: "fun-3",
    title: "东北大叔零下十度直播卖冰棍，路人全看呆",
    summary: "他说天越冷越好卖，网友：这才是赛博东北。",
    content: [
      "零下十度的街头，一位东北大叔支起小摊，一边跺脚取暖一边熟练地直播卖冰棍，画面喜感十足。",
      "面对镜头，他一本正经地说：天越冷冰棍卖得越好，这叫反向操作。围观的路人看得目瞪口呆，纷纷掏出手机拍摄。",
      "有网友评论，这是冬天限定的快乐，也是属于这座城市的独特浪漫。",
    ],
    cover: "https://readdy.ai/api/search-image?query=fun%20video%20thumbnail%20about%20a%20northeast%20man%20livestreaming%20selling%20popsicles%20in%20freezing%20winter%20streets%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-fun-03&orientation=landscape",
    categoryId: "fun",
    categoryName: "趣味短片",
    publishTime: "2026-10-10 16:44",
    views: 1980340,
    likes: 156220,
    duration: "01:52",
    source: "综合报道",
    tags: ["搞笑"],
  },
  {
    id: "fun-4",
    title: "儿童版足球赛惊现世界波，教练当场起立鼓掌",
    summary: "一脚远射直挂死角，全场家长都站了起来。",
    content: [
      "在一场青少年足球邀请赛中，一名小球员在中场附近起脚远射，皮球划出漂亮弧线直挂球门死角。",
      "场边的教练与家长几乎同时起立鼓掌，连对方替补席都忍不住为这一脚喝彩。",
      "赛后教练表示，孩子的天赋固然重要，但更让人欣慰的是他敢于尝试的那份自信。",
    ],
    cover: "https://readdy.ai/api/search-image?query=fun%20video%20thumbnail%20about%20kids%20playing%20football%20scoring%20an%20amazing%20long%20range%20goal%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-fun-04&orientation=landscape",
    categoryId: "fun",
    categoryName: "趣味短片",
    publishTime: "2026-10-09 14:10",
    views: 1245890,
    likes: 92140,
    duration: "02:38",
    source: "综合报道",
    tags: ["现场"],
  },
  {
    id: "film-1",
    title: "年度科幻大片首支预告发布，特效镜头逐帧解析",
    summary: "两分三十秒的预告里，藏着至少五处关键剧情暗示。",
    content: [
      "备受关注的年度科幻新片日前发布首支正式预告，两分三十秒的画面信息量巨大，特效质感相比前作有明显提升。",
      "从构图来看，导演延续了标志性的冷峻美学，同时在色彩上加入更多暖调，人物关系也通过几个快速剪辑交代清楚。",
      "制片方表示，影片已完成主要后期工作，具体上映档期将在宣传周期内正式公布。",
    ],
    cover: "https://readdy.ai/api/search-image?query=film%20news%20video%20thumbnail%20about%20a%20sci%20fi%20movie%20trailer%20with%20glowing%20visual%20effects%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-film-01&orientation=landscape",
    categoryId: "film",
    categoryName: "影视资讯",
    publishTime: "2026-10-13 10:25",
    views: 1678320,
    likes: 121430,
    duration: "07:05",
    source: "吃瓜视频原创",
    tags: ["新片", "幕后"],
  },
  {
    id: "film-2",
    title: "古装剧定档海报曝光，主演阵容引发热议",
    summary: "一张海报三处细节，网友已经开启了考据模式。",
    content: [
      "一部备受期待的古装剧正式公布定档海报。画面以深色为底，主演造型沉稳大气，整体质感偏向写实风格。",
      "眼尖的网友从海报细节中捕捉到不少线索，包括道具纹样与场景布置，纷纷展开讨论与考据。",
      "剧组透露，该剧在场景搭建与后期制作上投入了大量精力，希望为观众呈现更有代入感的故事。",
    ],
    cover: "https://readdy.ai/api/search-image?query=film%20news%20video%20thumbnail%20about%20a%20costume%20drama%20poster%20reveal%20with%20elegant%20cast%20lineup%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-film-02&orientation=landscape",
    categoryId: "film",
    categoryName: "影视资讯",
    publishTime: "2026-10-11 17:36",
    views: 1320450,
    likes: 96420,
    duration: "04:47",
    source: "综合报道",
    tags: ["新片", "热议"],
  },
  {
    id: "film-3",
    title: "纪录片《城市凌晨》上线，记录夜班劳动者的一天",
    summary: "镜头没有旁白，只有凌晨三点这座城市的声音。",
    content: [
      "纪录片《城市凌晨》近日正式上线，全片没有一句旁白，却用真实的画面讲述了夜班劳动者的日常。",
      "凌晨的便利店、清洁车、急诊室与早餐铺，被镜头一一串起，构成一座城市最安静的呼吸。",
      "影片上线后获得不少好评，有观众留言说，看完之后想对所有深夜仍在工作的人说一句辛苦了。",
    ],
    cover: "https://readdy.ai/api/search-image?query=film%20news%20video%20thumbnail%20about%20a%20documentary%20about%20night%20shift%20workers%20in%20a%20city%20at%20dawn%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-film-03&orientation=landscape",
    categoryId: "film",
    categoryName: "影视资讯",
    publishTime: "2026-10-09 20:58",
    views: 876220,
    likes: 71230,
    duration: "08:16",
    source: "综合报道",
    tags: ["新片"],
  },
  {
    id: "film-4",
    title: "动画电影幕后特辑：一个镜头打磨了整整三个月",
    summary: "从分镜到渲染，制作团队还原了一颗泪珠的诞生。",
    content: [
      "一部动画电影的幕后特辑公开了制作过程，其中一段主角落泪的镜头，从分镜设计到最终渲染足足打磨了三个月。",
      "团队介绍，为了让情绪更自然，他们在光影与毛发细节上反复调整，光是泪珠的折射效果就测试了数十个版本。",
      "不少观众看完表示，原来短短几秒的画面背后，是无数创作者日复一日的坚持。",
    ],
    cover: "https://readdy.ai/api/search-image?query=film%20news%20video%20thumbnail%20about%20behind%20the%20scenes%20of%20an%20animated%20film%20studio%20with%20artists%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-film-04&orientation=landscape",
    categoryId: "film",
    categoryName: "影视资讯",
    publishTime: "2026-10-08 13:12",
    views: 693110,
    likes: 58940,
    duration: "06:38",
    source: "综合报道",
    tags: ["幕后"],
  },
  {
    id: "music-1",
    title: "livehouse现场：独立乐队一首歌唱哭全场观众",
    summary: "前奏响起的瞬间，观众自发打开了手机手电筒。",
    content: [
      "在一场小型livehouse演出中，一支独立乐队唱起代表作，前奏刚响起，台下观众便自发举起手机手电筒，现场瞬间变成一片星海。",
      "主唱唱到副歌时明显哽咽，索性把话筒转向观众，全场大合唱的场面令人动容。",
      "演出结束后，乐队在社交平台写道：感谢每一位愿意陪我们唱到最后的你。",
    ],
    cover: "https://readdy.ai/api/search-image?query=music%20video%20thumbnail%20about%20a%20livehouse%20concert%20crowd%20moved%20to%20tears%20by%20an%20indie%20band%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-music-01&orientation=landscape",
    categoryId: "music",
    categoryName: "音乐现场",
    publishTime: "2026-10-12 22:41",
    views: 1456890,
    likes: 138220,
    duration: "05:52",
    source: "吃瓜视频原创",
    tags: ["现场", "独家"],
  },
  {
    id: "music-2",
    title: "翻唱经典老歌走红，街头歌手一夜涨粉百万",
    summary: "一首没有修音的清唱，让无数人停下脚步。",
    content: [
      "一位街头歌手在地铁口翻唱了一首经典老歌，路人随手拍摄的视频在网络上迅速传播，短短一夜之间账号涨粉百万。",
      "视频里没有华丽的编曲与修音，只有干净的人声和略显嘈杂的街头环境音，却格外真实动人。",
      "面对突然而来的关注，他表示会继续在街头唱歌，把更多好听的旋律唱给路过的每一个人。",
    ],
    cover: "https://readdy.ai/api/search-image?query=music%20video%20thumbnail%20about%20a%20street%20singer%20performing%20a%20classic%20cover%20song%20at%20night%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-music-02&orientation=landscape",
    categoryId: "music",
    categoryName: "音乐现场",
    publishTime: "2026-10-10 21:09",
    views: 2014580,
    likes: 176540,
    duration: "04:29",
    source: "综合报道",
    tags: ["现场", "热议"],
  },
  {
    id: "music-3",
    title: "音乐节首日回顾：万人合唱名场面合集",
    summary: "从黄昏到深夜，这些瞬间值得被反复回看。",
    content: [
      "为期三天的音乐节拉开帷幕，首日便迎来万人级人流。从黄昏的第一首歌到最后一场烟火，现场高潮不断。",
      "压轴歌手上台时，全场自发合唱，声浪几乎盖过音响，后台乐队成员也忍不住跟着哼唱。",
      "主办方提醒，后续两天请合理安排到场时间，注意防晒与补水，共同维护良好的观演秩序。",
    ],
    cover: "https://readdy.ai/api/search-image?query=music%20video%20thumbnail%20about%20a%20huge%20music%20festival%20crowd%20singing%20together%20under%20lights%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-music-03&orientation=landscape",
    categoryId: "music",
    categoryName: "音乐现场",
    publishTime: "2026-10-08 23:55",
    views: 1130770,
    likes: 89340,
    duration: "09:14",
    source: "综合报道",
    tags: ["回顾"],
  },
  {
    id: "music-4",
    title: "民谣歌手新专辑上线，歌词被网友赞为诗意",
    summary: "十首歌讲十座城，也讲十个普通人的故事。",
    content: [
      "一位民谣歌手的新专辑正式上线，整张专辑共十首歌，每一首都对应一座城市与其中一位普通人。",
      "专辑文案写道，希望这些歌能陪你在加班的出租车上、在深夜回家的路上，轻轻哼成自己的故事。",
      "上线首日，多首歌曲进入热门榜单，网友评价歌词干净又有画面感，像一封写给生活的信。",
    ],
    cover: "https://readdy.ai/api/search-image?query=music%20video%20thumbnail%20about%20a%20folk%20singer%20with%20an%20acoustic%20guitar%20in%20warm%20studio%20light%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-music-04&orientation=landscape",
    categoryId: "music",
    categoryName: "音乐现场",
    publishTime: "2026-10-07 18:30",
    views: 782450,
    likes: 65780,
    duration: "03:47",
    source: "综合报道",
    tags: ["新片"],
  },
  {
    id: "game-1",
    title: "电竞总决赛决胜局，逆风翻盘全场沸腾",
    summary: "落后一万经济的绝境翻盘，解说嗓音都喊破了。",
    content: [
      "电竞总决赛来到决胜局，其中一方在开局便陷入巨大劣势，经济落后一度超过一万，看似败局已定。",
      "然而凭借一波关键团战的完美决策，他们完成了几乎不可能的翻盘，现场观众全体起立呐喊。",
      "赛后采访中，队长说：只要比赛没结束，我们就还有机会。这句话被不少玩家截图收藏。",
    ],
    cover: "https://readdy.ai/api/search-image?query=gaming%20video%20thumbnail%20about%20an%20esports%20final%20deciding%20game%20with%20a%20dramatic%20comeback%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-game-01&orientation=landscape",
    categoryId: "game",
    categoryName: "游戏电竞",
    publishTime: "2026-10-13 23:20",
    views: 2560310,
    likes: 231450,
    duration: "10:02",
    source: "吃瓜视频原创",
    tags: ["现场", "热议"],
  },
  {
    id: "game-2",
    title: "新游上线首日服务器挤爆，官方紧急扩容",
    summary: "排队人数一度突破两百万，补偿方案也来了。",
    content: [
      "一款备受期待的新游戏正式上线，开服不到十分钟，服务器便因涌入人数过多而出现排队现象。",
      "官方随后发布公告，表示正在紧急扩容并修复相关问题，同时为玩家准备了相应的补偿礼包。",
      "不少玩家一边吐槽一边继续排队，笑称这是\"又爱又恨\"的典型体验。",
    ],
    cover: "https://readdy.ai/api/search-image?query=gaming%20video%20thumbnail%20about%20players%20rushing%20into%20a%20brand%20new%20online%20game%20on%20launch%20day%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-game-02&orientation=landscape",
    categoryId: "game",
    categoryName: "游戏电竞",
    publishTime: "2026-10-11 11:47",
    views: 1478230,
    likes: 115670,
    duration: "06:25",
    source: "综合报道",
    tags: ["热议"],
  },
  {
    id: "game-3",
    title: "职业选手蒙眼挑战通关，观众直呼不可能",
    summary: "靠着肌肉记忆与声音判断，他完成了这场疯狂挑战。",
    content: [
      "一位职业选手在直播中发起蒙眼挑战，全程依靠对地图的熟悉与音效判断进行操作，目标是通关一段高难度关卡。",
      "经历多次失败后，他终于在第六次尝试中完成挑战，直播间弹幕瞬间被刷屏。",
      "他事后表示，这样的挑战更多是娱乐性质，真正想告诉大家的是，熟练背后是成千上万次重复练习。",
    ],
    cover: "https://readdy.ai/api/search-image?query=gaming%20video%20thumbnail%20about%20a%20pro%20gamer%20doing%20a%20blindfolded%20speedrun%20challenge%20on%20stream%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-game-03&orientation=landscape",
    categoryId: "game",
    categoryName: "游戏电竞",
    publishTime: "2026-10-09 22:15",
    views: 1067390,
    likes: 88450,
    duration: "12:38",
    source: "综合报道",
    tags: ["现场"],
  },
  {
    id: "game-4",
    title: "怀旧游戏展现场，八零后集体回忆杀",
    summary: "那些曾经排队投币的老机器，现在成了合照对象。",
    content: [
      "一场怀旧游戏展近日举办，展厅内陈列了数十台经典街机与老式主机，吸引大批观众前来重温青春。",
      "不少参观者带着孩子一起体验，指着屏幕讲解自己当年的\"战绩\"，场面温馨又欢乐。",
      "策展人表示，希望借由这些老物件，让不同年代的人都能理解游戏带来的简单快乐。",
    ],
    cover: "https://readdy.ai/api/search-image?query=gaming%20video%20thumbnail%20about%20a%20retro%20video%20game%20exhibition%20with%20nostalgic%20arcade%20cabinets%20with%20vibrant%20editorial%20style%20warm%20orange%20and%20blue%20gray%20tones%20clean%20simple%20background%20soft%20studio%20lighting%20high%20detail%20professional%20media%20composition&width=800&height=500&seq=cg-game-04&orientation=landscape",
    categoryId: "game",
    categoryName: "游戏电竞",
    publishTime: "2026-10-07 15:40",
    views: 634210,
    likes: 52340,
    duration: "07:58",
    source: "综合报道",
    tags: ["回顾"],
  },
];

export const hotKeywords = [
  "顶流歌手",
  "暴雨互助",
  "猫咪日常",
  "科幻大片",
  "音乐节",
  "电竞总决赛",
  "街头歌手",
  "社会正能量",
];